<template>
  <div class="full" ref="rect">
    <canvas class="full absolute top-0 left-0" ref="canvas"></canvas>
    <div class="absolute top-0 left-0">
      Repulsive Force: <input type="range" step="0.001" min="10" max="700" v-model="forceSize" @input="onForce()">
      <pre v-if="pointedTo" class=" pointer-events-none opacity-50">{{ pointedTo }}</pre>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'

export default {
  data () {
    return {
      center: {
        x: 0,
        y: 0
      },
      charge: false,
      simulation: false,
      forceSize: 50,
      pointedTo: false
    }
  },
  methods: {
    onForce () {
      if (this.simulation) {
        this.$nextTick(() => {
          this.charge = this.charge || d3.forceManyBody()
          this.charge.strength(() => {
            return -1 * this.forceSize
          })
          this.simulation.force('charge', this.charge)
          this.simulation.alphaTarget(0.5)
          this.simulation.restart()
        })
      }
    },
    init (json) {
      var canvas = this.$refs['canvas']
      var rect = this.$refs.rect.getBoundingClientRect()
      var width = rect.width
      var height = rect.height
      canvas.width = width
      canvas.height = height

      var context = canvas.getContext('2d')
      context.font = '20px Arial'

      var simulation = this.simulation = d3.forceSimulation()
        .force('link', d3.forceLink().id(function (d) { return d.id }))
        .force('charge', d3.forceManyBody())
        .force('center', d3.forceCenter(width / 2, height / 2))

      window.addEventListener('resize', () => {
        this.$nextTick(() => {
          rect = this.$refs['rect'].getBoundingClientRect()
          width = rect.width
          height = rect.height
          canvas.width = width
          canvas.height = height
          simulation.force('center', d3.forceCenter(width / 2, height / 2))
        })
      })

      // d3.json('miserables.json', function (error, graph) {
      //   if (error) throw error
      // })

      let hover = false
      var onLoad = (graph) => {
        simulation
          .nodes(graph.nodes)
          .on('tick', ticked)

        simulation.force('link')
          .links(graph.links)

        d3.select(canvas)
          .call(
            d3.drag()
              .container(canvas)
              .subject(dragsubject)
              .on('start', dragstarted)
              .on('drag', dragged)
              .on('end', dragended)
          )
        let detectHover = () => {
          let found = simulation.find(d3.event.x, d3.event.y)
          if (found && (found.x - d3.event.x < 8 && found.y - d3.event.y < 8)) {
            hover = found
          } else {
            hover = false
          }
        }
        let setLegend = () => {
          if (hover) {
            this.pointedTo = {
              from: hover.label,
              to: graph.links.filter(l => l.source.id === hover.id).map(e => e.target.label)
            }
          } else {
            this.pointedTo = false
          }
          this.$forceUpdate()
        }

        d3.select(canvas)
          .on('mousemove', () => {
            detectHover()
          })
          .on('click', () => {
            setLegend()
          })
          .on('touchstart', () => {
            detectHover()
            setLegend()
            dragstarted()
          })
          .on('touchmove', () => {
            detectHover()
            dragged()
          })
          .on('touchend', () => {
            dragended()
          })

        function ticked () {
          context.clearRect(0, 0, width, height)

          graph.links.forEach(drawLink)

          context.beginPath()
          graph.nodes.forEach(drawNode)
          context.fill()
          context.stroke()

          graph.nodes.forEach(drawLabel)
        }

        function dragsubject () {
          return simulation.find(d3.event.x, d3.event.y)
        }
      }

      function dragstarted () {
        if (!d3.event.active) simulation.alphaTarget(0.3).restart()
        d3.event.subject.fx = d3.event.subject.x
        d3.event.subject.fy = d3.event.subject.y
      }

      function dragged () {
        d3.event.subject.fx = d3.event.x
        d3.event.subject.fy = d3.event.y
      }

      function dragended () {
        if (!d3.event.active) simulation.alphaTarget(0)
        d3.event.subject.fx = null
        d3.event.subject.fy = null
      }

      function drawLink (d) {
        context.beginPath()
        context.moveTo(d.source.x, d.source.y)
        context.lineTo(d.target.x, d.target.y)
        if (hover) {
          if (d.source.id === hover.id) {
            context.strokeStyle = '#0a0a0a'
          } else {
            context.strokeStyle = 'rgba(200,200,200,0.5)'
          }
        } else {
          context.strokeStyle = '#bababa'
        }
        context.stroke()
      }

      // function drawNode (d) {
      //   context.moveTo(d.x + 3, d.y)
      //   context.arc(d.x, d.y, 3, 0, 2 * Math.PI)
      // }

      function drawNode (d) {
        if (hover) {
          if (d.id === hover.id) {
            context.fillStyle = 'rgba(0,0,0,1.0)'
            context.strokeStyle = 'rgba(0,0,0,1.0)'
          } else {
            context.fillStyle = 'rgba(0,0,0,0.2)'
            context.strokeStyle = 'rgba(0,0,0,0.2)'
          }

          context.moveTo(d.x + 5, d.y)
          context.arc(d.x, d.y, 5, 0, 2 * Math.PI)
        } else {
          context.strokeStyle = 'white'
          context.moveTo(d.x + 5, d.y)
          context.arc(d.x, d.y, 5, 0, 2 * Math.PI)
        }
      }

      function drawLabel (d) {
        if (hover && hover.id === d.id) {
          context.fillStyle = '#1a1a1a'
          context.fillText(d.id, d.x + 10, d.y + 3)
        }
      }

      onLoad(json)
    }
  },
  mounted () {
    let graph = require('../json/d3.dummy-data.json')
    graph.nodes.forEach((b) => {
      b.label = b.id
    })
    this.init(graph)
  }
}
</script>

<style>

</style>
